import { render, staticRenderFns } from "./ComprobanteNota.vue?vue&type=template&id=866e01aa"
import script from "./ComprobanteNota.vue?vue&type=script&lang=js"
export * from "./ComprobanteNota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports